







































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  components: {},
  props: {
    propietarioInit: Object,
  },
  data: () => ({
    openDialog: false,
    email: [
      // value => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'Email incorrecto'
      (value) => (value === '' || /^\w[\.-_\w]*@[\w-_]+([\.]\w+)*(\.\w{2,3})+$/.test(value)) || 'Email incorrecto',
    ],
    tel: [ (value) => (value.length === 0 || value.length === 10) || 'Telefono incorrecto' ],
    nuevoContacto: {
      creationDateTime: '',
      creationUsername: '',
      tipo: '',
      value: '',
    },
    items: [
      { text: 'E-mail', value: 'EMAIL' },
      { text: 'SMS', value: 'TEL' },
    ],
    propietario: {},
  }),
  methods: {
    async AgregarContacto() {
      try {
        this.loading = true;
        this.nuevoContacto.creationDateTime = this.$moment().format();
        this.nuevoContacto.creationUsername = this.$store.getters.getUsername;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const propietario = this.propietario;
        const contacto = this.nuevoContacto;
        contacto.propietario = propietario;
        const datos = {admin, condo, propietario, contacto };
        console.debug('datos addContacto: %o', datos);
        const result = await this.$store.dispatch('addContacto', datos );
        console.debug('respuesta addContacto: %o', result);
        this.$toast.success('Contacto agregado');
      } catch (e) {
        this.$toast.error(e.response.data.message);
        console.error(e);
      }
      this.loading = false;
      this.openDialog = false;
      this.nuevoContacto = this.modeloNuevoContacto();
      this.$emit('reload', {});
    },
    CerrarDialog() {
      this.openDialog = false;
      this.nuevoContacto = this.modeloNuevoContacto();
    },
    modeloNuevoContacto() {
      return {
        creationDateTime: '',
        creationUsername: '',
        tipo: '',
        value: '',
      };
    },
    restrictChars($event) {
      if (this.nuevoContacto.tipo === 'TEL') {
        if (($event.charCode >= 48 && $event.charCode <= 57)) {
          return true;
        } else {
            $event.preventDefault();
        }
      } else if (this.nuevoContacto.tipo === 'EMAIL') {
        if ((this.nuevoContacto.value.indexOf('@') === -1) && ($event.charCode === 64)) {
          return true;
        } else if ($event.charCode !== 64) {
            return true;
        }
        $event.preventDefault();
      }
    },
    validarCorreo() {
      if (this.nuevoContacto.tipo === 'EMAIL') {
      if (/^\w[\.-_\w]*@[\w-_]+([\.]\w+)*(\.\w{2,3})+$/.test(this.nuevoContacto.value)) {
          return false;
        } else {
          return true;
        }
      } else if (this.nuevoContacto.tipo === 'TEL') {
        return false;
      }
      return true;
    },
  },
  computed: {
    contactTypeLabel() {
      if (this.nuevoContacto.tipo === 'EMAIL') {
        this.nuevoContacto.value = '';
        return 'E-mail';
      } else if (this.nuevoContacto.tipo === 'TEL') {
        this.nuevoContacto.value = '';
        return 'Número de teléfono';
      } else {
        return 'Datos del contacto';
      }
    },
    isContactDataEmpty() {
      if (!this.nuevoContacto.tipo || !this.nuevoContacto.value) {
        return true;
      } else {
        return this.validarCorreo();
      }
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.propietario = JSON.parse(JSON.stringify(this.propietarioInit));
      }
      if (!this.openDialog) {
        this.propietario = {};
      }
    },
  },
});
